module.exports = __webpack_public_path__ + "static/media/arrow_down.986f67b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/stravaAuth/img/arrow_down.svg
// module id = 601
// module chunks = 0